export default {
  title: 'Cadastro de Usuários',
  description: 'Cadastre usuários e mantenha seus dados pessoais, contatos e documentos necessários para acesso aos sistemas.',
  labels: {
    subtotal: 'Subtotal:',
    oldest: 'Mais velho',
  },
  groups: {
    personalData: 'Dados Pessoais',
    contact: 'Contato',
    documents: 'Documentos',
    financial: 'Financeiro',
  },
  fields: {
    name: 'Nome',
    birthday: 'Nascimento',
    birthdayFrom: 'Nascimento de',
    birthdayTo: 'Nascimento até',
    pcd: 'PCD',
    gender: 'Gênero',
    cpf: 'CPF',
    rg: 'RG',
    cnh: 'CNH',
    bank: 'Banco',
    capital: 'Capital',
    phone: 'Telefone',
  },
  options: {
    gender: {
      M: 'Masculino',
      F: 'Feminino',
    },
  },
  export: {
    extract: 'Extrato',
    contacts: 'Contatos',
  },
  mfa: {
    legend: 'Entre com seu código de segurança',
    code: 'Código',
  },
};
